import styled from 'styled-components';
import { Typ30, Typ80, Typ60, Typ51 } from 'dc/Typ';

export const Wrapper = styled.div`
  width: 100%;
  height: auto;
  margin: 0 auto;
  display: flex;
  padding: 80px 0 170px;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: linear-gradient(169.97deg, #007079 0%, #1db3d9 100%);
  @media only screen and (max-width: 600px) {
    padding: 88px 16px 102px;
  }
`;

export const Title = styled(Typ80)`
  color: #fff;
  margin-top: 70px;
  @media only screen and (max-width: 600px) {
    margin-top: 0;
    font-size: 32px;
    line-height: 40px;
  }
`;

export const Text = styled(Typ51)`
  color: #fff;
  margin: 24px 0 0;
  @media only screen and (max-width: 600px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

export const ListText = styled(Typ60)`
  color: #fff;
  margin: 8px 0 0;
  @media only screen and (max-width: 600px) {
    margin: 2px 0 0;
    font-size: 18px;
    line-height: 24px;
  }
`;

export const SubText = styled(Typ30)`
  color: #fff;
  margin-top: 40px;
  @media only screen and (max-width: 600px) {
    margin-top: 10px;
    font-size: 12px;
    line-height: 14px;
  }
`;
